import React from 'react';

export type GuidesToggleCardHeaderProps = {
    children?: React.ReactNode | React.ReactNode[];
    onClick?: () => void;
    isActive?: boolean;
    hasCloseActionIcon?: boolean;
};

const GuidesToggleCardHeader: React.FC<GuidesToggleCardHeaderProps> = (props) => {
    const { children, onClick } = props;
    const onClickHandler = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <button className="guides-toggle-card-header" onClick={onClickHandler}>
            <span className="guides-toggle-card-header__title">{children}</span>
        </button>
    );
};

export default GuidesToggleCardHeader;
